// extracted by mini-css-extract-plugin
module.exports = {"Skills":"Skills_Skills__3uc3R","logo":"Skills_logo__129vW"};